import { Injectable } from "@angular/core";
import {
  LorenBaseEndpointsService
} from "../../../../shared/services/loren-base-endpoints-service/loren-base-endpoints.service";
import { LorenAssetHistoryArg } from "../loren-asset-service/interfaces/loren-asset-history-arg.interface";

/**
 * @deprecated Build endpoint URLs directly inside the service that calls them.
 */
@Injectable({
  providedIn: "root",
})
export class LorenAssetEndpointsService extends LorenBaseEndpointsService {
  constructor() {
    super();
  }

  public assets() {
    return `${this.getApiServerUrl()}/assets`;
  }

  public pagedAssets(
    pageNum: number,
    pageSize: number,
    assets: number[] = null,
    filterString: string = null
  ) {
    const ids = assets ? `&ids=${assets.join(",")}` : "";

    return `${this.getApiServerUrl()}/assets/page?page=${pageNum}&size=${pageSize}${ids}${
      filterString ? `&assetName=${filterString}` : ""
    }`;
  }

  public getAllAssets() {
    return `${this.getApiServerUrl()}/assets/view`;
  }

  public assetTypes() {
    return `${this.getApiServerUrl()}/asset-types`;
  }

  public binaryHistory(arg: LorenAssetHistoryArg) {
    return `${this.getApiServerUrl()}/assets/meterings/${
      arg.meteringId
    }/binary-history?dateFrom=${arg.from.toString()}&dateTo=${arg.to.toString()}`;
  }

  public assetImage(id: number) {
    return `${this.getApiServerUrl()}/assets/${id}/images`;
  }

  public assetPhoto(id: number) {
    return `${this.getApiServerUrl()}/assets/${id}/photos`;
  }

  public trackingPointsSummary() {
    return `${this.getApiServerUrl()}/assets/meterings/track-points-summary`;
  }

  public addNote(meteringId: number) {
    return `${this.getApiServerUrl()}/assets/meterings/${meteringId}/note`;
  }

  public getAnalysis() {
    return `${this.getApiServerUrl()}/assets/meterings/period/analysis`;
  }
}
